import {Component} from 'react';
import h from 'react-hyperscript';

class Image extends Component {
  createAttributes() {
    const attributes = {
      src: this.props.src,
      alt: this.props.alt,
      className: this.props.className,
      datatarget: null,
    };

    if (this.props.srcSet) {
      attributes.srcSet = `${this.props.srcSet.standard} 1x,
        ${this.props.srcSet.retina} 2x`;
    }

    if (!this.props.alt) {
      attributes.alt = '';
    }

    if (this.props.datatarget) {
      attributes.datatarget = this.props.datatarget;
    }

    return attributes;
  }

  render() {
    return (
      h('img', this.createAttributes(), null)
    );
  }
}

export default Image;
